import { ReactNode } from 'react';
import { ToastContainer } from 'react-toastify';

/** Layout mínimo para páginas públicas do portal do candidato (sem autenticação interna). */
export default function PublicCandidateShell({ children }: { children: ReactNode }) {
  return (
    <>
      <ToastContainer position="top-left" pauseOnFocusLoss={false} />
      <div className="container container-interno overflow-auto py-3">
        {children}
      </div>
    </>
  );
}
